import React, { Component } from "react";
//import "../login/style.scss";
import { Cookies } from "react-cookie";
import { Route, Redirect, Link } from "react-router-dom";
import { observer } from "mobx-react";
import UserStore from "../../stores/UserStore";
import Inner from "../template/Inner";
import Spinner from "react-spinkit";
import api from "../../lib/api";
import Button from "@material-ui/core/Button";
import Modal from "@material-ui/core/Modal";
import { FiX } from "react-icons/fi";
import { Formik } from "formik";
import AppStore from "../../stores/AppStore";

import { DndProvider } from "react-dnd";
import HTML5Backend from "react-dnd-html5-backend";
import AgentList from "./components/AgentList";

import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";

@observer
class Agents extends Component {
  constructor(props) {
    super(props);
    this.state = {
      agents: [],
      error: false,
      createModal: false,
      toAgent: null,
      sendInviteEmail: true,
      resultLimit: 10,
      resultOffset: 0,
      resultsFrom: 0,
      resultsTo: 0,
      resultsTotal: 0,
      resultSort: ""
    };
  }

  componentDidMount() {
    const query = new URLSearchParams(window.location.search);
    const limitQ = query.get("limit");
    const offsetQ = query.get("offset");
    const sortQ = query.get("sort");

    if (limitQ && offsetQ) {
      this.setState({
        resultLimit: parseInt(limitQ),
        resultOffset: parseInt(offsetQ)
      });
    }

    if (sortQ) {
      this.setState({
        resultSort: sortQ
      });
    }

    setTimeout(() => {
      this.loadAgents();
    }, 0);
  }

  loadAgents() {
    this.setState({
      resultsTotal: 0
    });

    api.getAgents(
      this.state.resultLimit,
      this.state.resultOffset,
      this.state.resultSort,
      response => {
        this.setState({
          agents: response.agents,
          resultsTotal: response.total,
          resultsFrom: response.from,
          resultsTo: response.to
        });
      },
      error => {
        this.setState({ error: true });
      }
    );
  }

  updateHistory() {
    this.props.history.push(
      `${window.location.pathname}?offset=${parseInt(
        this.state.resultOffset
      )}&limit=${parseInt(this.state.resultLimit)}&sort=${
        this.state.resultSort
      }`
    );
  }

  updateLimit(limit) {
    this.setState({
      resultLimit: limit
    });

    setTimeout(() => {
      this.updateHistory();

      this.loadAgents();
    }, 0);
  }

  updateSort(sort) {
    this.setState({
      resultSort: sort
    });

    setTimeout(() => {
      this.updateHistory();

      this.loadAgents();
    }, 0);
  }

  page(type) {
    if (type == "next") {
      this.setState({
        resultOffset: this.state.resultOffset + this.state.resultLimit
      });
    } else if (type == "prev") {
      this.setState({
        resultOffset: this.state.resultOffset - this.state.resultLimit
      });
    } else if (type == "last") {
      this.setState({
        resultOffset: this.state.resultsTotal - this.state.resultLimit
      });
    } else if (type == "first") {
      this.setState({
        resultOffset: 0
      });
    }

    setTimeout(() => {
      this.updateHistory();

      this.loadAgents();
      window.scrollTo(0, 0);
    }, 0);
  }

  handleClose = () => {
    this.setState({ createModal: false });
  };

  csv() {
    api.getAgentsCSV(
      response => {
        if (window.navigator && window.navigator.msSaveOrOpenBlob && false) {
          let blob = new Blob([response], { type: "text/csv" });
          window.navigator.msSaveOrOpenBlob(blob, "agents.csv");
        } else {
          // other browsers
          let file = new File([response], "agents.csv", {
            type: "text/csv"
          });

          const isSafari = /^((?!chrome|android).)*safari/i.test(
            navigator.userAgent
          );
          if (isSafari) {
            let blob = new Blob([response], { type: "text/csv" });
            let exportUrl = URL.createObjectURL(blob);
            var e = document.createElement("a");
            e.href = exportUrl;
            e.target = "_self";
            e.setAttribute("download", "download");
            document.body.appendChild(e);
            e.click();
            document.body.removeChild(e);

            //window.location.assign(exportUrl);
            //window.open(exportUrl, "_self");
            //URL.revokeObjectURL(exportUrl);
          } else {
            let exportUrl = URL.createObjectURL(file);
            window.location.assign(exportUrl);
            URL.revokeObjectURL(exportUrl);
          }
        }
      },
      error => {
        //
      }
    );
  }

  planWarning() {
    if (AppStore.app_data.plan.limit <= 0) {
      return null;
    }

    if (this.state.agents.length < AppStore.app_data.plan.limit) {
      return null;
    }

    return (
      <div class="row">
        <div class="col-md-12">
          <div
            class="alert alert-border-warning  alert-dismissible fade show"
            role="alert"
            style={{
              backgroundColor: "#fff"
              /*boxShadow: "1px 2px 10px rgba(0,0,0,0.3)"*/
            }}
          >
            <div class="d-flex">
              <div class="icon">
                <i class="icon mdi mdi-alert-circle-outline" />
              </div>
              <div class="content">
                <strong>You've reached your plan limit for agents</strong>
                <br />
                Your current plan allows a maximum of{" "}
                <strong>{AppStore.app_data.plan.limit}</strong> agent
                {AppStore.app_data.plan.limit == 1 ? null : "s"}. To add more
                please contact{" "}
                <a
                  href="mailto:prosupport@homestack.com"
                  class="text-underline"
                >
                  prosupport@homestack.com
                </a>
                .
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  createAgentModal() {
    if (
      AppStore.app_data.plan.limit > 0 &&
      this.state.agents.length >= AppStore.app_data.plan.limit
    ) {
      return (
        <Modal open={this.state.createModal} onClose={this.handleClose}>
          <div style={styles.modal}>
            <div style={styles.modalTitle}>
              <h3>Please upgrade plan</h3>
              <div
                style={{
                  cursor: "pointer",
                  width: 20,
                  height: 20,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center"
                }}
                onClick={() => {
                  this.setState({ createModal: false });
                }}
              >
                <FiX style={styles.menuIcon} />
              </div>
            </div>

            <p>
              Your current plan allows a maximum of{" "}
              <strong>{AppStore.app_data.plan.limit}</strong> agent
              {AppStore.app_data.plan.limit == 1 ? null : "s"}. To add more
              please contact{" "}
              <a href="mailto:prosupport@homestack.com" class="text-underline">
                prosupport@homestack.com
              </a>
              .
            </p>
          </div>
        </Modal>
      );
    }

    return (
      <Modal open={this.state.createModal} onClose={this.handleClose}>
        <div style={styles.modal}>
          <div style={styles.modalTitle}>
            <h2>Create new agent</h2>
            <div
              style={{
                cursor: "pointer",
                width: 20,
                height: 20,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
              onClick={() => {
                this.setState({ createModal: false });
              }}
            >
              <FiX style={styles.menuIcon} />
            </div>
          </div>

          <Formik
            initialValues={{
              display_name: null,
              email: null,
              password: null
            }}
            validate={values => {
              let errors = {};

              if (!values.display_name) {
                errors.display_name = "Required";
              }

              if (!values.password) {
                errors.password = "Required";
              } else if (values.password.length < 6) {
                errors.password = "Password must be at least 6 characters";
              }

              if (!values.email) {
                errors.email = "Required";
              } else if (
                !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
              ) {
                errors.email = "Invalid email address";
              }
              return errors;
            }}
            onSubmit={(values, { setSubmitting }) => {
              setTimeout(() => {
                values.send_email = this.state.sendInviteEmail;
                //alert(JSON.stringify(values, null, 2));

                api.createAgent(
                  values,
                  response => {
                    //alert(JSON.stringify(response));
                    this.setState({ toAgent: response.id });
                  },
                  error => {
                    alert(error.response.data.message);
                  }
                );

                setSubmitting(false);
              }, 400);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting
              /* and other goodies */
            }) => (
              <form onSubmit={handleSubmit}>
                <p>
                  <label for="display_name">Name</label>
                  <input
                    type="text"
                    name="display_name"
                    class="form-control"
                    id="display_name"
                    placeholder="Agent name"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.display_name}
                  />
                  <span className="form-error">
                    {errors.display_name &&
                      touched.display_name &&
                      errors.display_name}
                  </span>
                </p>

                <p>
                  <label for="email">Email</label>
                  <input
                    type="email"
                    name="email"
                    class="form-control"
                    id="email"
                    placeholder="Agent email"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.email}
                  />
                  <span className="form-error">
                    {errors.email && touched.email && errors.email}
                  </span>
                </p>

                <p>
                  <label for="password">Password</label>
                  <input
                    type="password"
                    name="password"
                    class="form-control"
                    id="password"
                    placeholder="Agent password"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.password}
                  />
                  <span className="form-error">
                    {errors.password && touched.password && errors.password}
                  </span>
                </p>

                <p>
                  <FormGroup row>
                    <FormControlLabel
                      control={
                        <Switch
                          color="primary"
                          checked={this.state.sendInviteEmail}
                          onChange={() => {
                            const tog = !this.state.sendInviteEmail;
                            this.setState({
                              sendInviteEmail: tog
                            });
                          }}
                          value="1"
                        />
                      }
                      label="Send email notice"
                    />
                  </FormGroup>
                </p>

                <p>
                  <button
                    class="btn btn-primary"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    Create agent{" "}
                    {this.state.sendInviteEmail ? "& send email" : null}
                  </button>
                </p>

                <p>
                  <small>You can add more details after creating.</small>
                </p>
              </form>
            )}
          </Formik>
        </div>
      </Modal>
    );
  }

  pagination() {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "row",
          marginBottom: 5,
          alignItems: "center"
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center"
          }}
        >
          <div class="fddorm-group">
            <select
              value={this.state.resultLimit}
              class="form-control"
              onChange={e => {
                this.updateLimit(e.target.value);
              }}
            >
              <option value="0">Show all</option>
              <option value="10">Show 10</option>
              <option value="25">Show 25</option>
              <option value="50">Show 50</option>
            </select>
          </div>
          <div style={{ marginLeft: 10 }}>
            <strong>
              Showing {this.state.resultsFrom} - {this.state.resultsTo} of{" "}
              {this.state.resultsTotal}
            </strong>
          </div>
          <div style={{ marginLeft: 30 }}>
            <strong>Order by</strong>
          </div>
          <div class="fddorm-group" style={{ marginLeft: 10 }}>
            <select
              value={this.state.resultSort}
              class="form-control"
              onChange={e => {
                this.updateSort(e.target.value);
              }}
            >
              <option value="">Sorted order</option>
              <option value="a">A-Z</option>
              <option value="z">Z-A</option>
              <option value="n">Newest</option>
              <option value="o">Oldest</option>
            </select>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row"
          }}
        >
          {this.state.resultsFrom > 1 && (
            <>
              <button
                onClick={() => {
                  this.page("first");
                }}
                class="btn btn-sm btn-secondary"
              >
                First
              </button>
              <div style={{ width: 10 }}></div>
              <button
                onClick={() => {
                  this.page("prev");
                }}
                class="btn btn-sm btn-primary"
              >
                &larr; Previous
              </button>
            </>
          )}
          <div style={{ width: 10 }}></div>
          {this.state.resultsTo < this.state.resultsTotal && (
            <>
              <button
                onClick={() => {
                  this.page("next");
                }}
                class="btn btn-sm btn-primary"
              >
                Next &rarr;
              </button>
              <div style={{ width: 10 }}></div>
              <button
                onClick={() => {
                  this.page("last");
                }}
                class="btn btn-sm btn-secondary"
              >
                Last
              </button>
            </>
          )}
        </div>
      </div>
    );
  }

  agents() {
    if (this.state.error) {
      return (
        <div className="centerBox">
          <img src="https://bk.homestack.com/assets/img/not-found.svg" />
          <h2>Unable to load data</h2>
          <p>
            <button
              onClick={() => {
                this.setState({ error: false });
                this.loadAgents();
              }}
            >
              Try again
            </button>
          </p>
        </div>
      );
    }

    if (!this.state.agents.length) {
      return (
        <div
          class="d-flex w-100 justify-content-center align-items-center"
          style={{ height: "100vh" }}
        >
          <div class="spinner-border text-warning" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      );
    }

    const { match } = this.props;

    return (
      <section class="admin-content">
        {this.createAgentModal()}

        <div class="bg-dark">
          <div class="container  m-b-30">
            <div class="row">
              <div class="col-12 text-white p-t-40 p-b-90">
                <div class="float-right">
                  {UserStore.isAdmin() && !AppStore.agentCardsChanged && (
                    <button
                      style={{ marginRight: 20 }}
                      onClick={() => {
                        this.csv();
                      }}
                      class="btn btn-primary"
                    >
                      <i class=" fe fe-download " /> Download CSV
                    </button>
                  )}

                  {!AppStore.agentCardsChanged && (
                    <button
                      onClick={() => {
                        this.setState({ createModal: true });
                      }}
                      class="btn btn-success"
                    >
                      New agent
                    </button>
                  )}

                  {AppStore.agentCardsChanged && (
                    <>
                      <button
                        style={{ marginRight: 20 }}
                        onClick={() => {
                          //alert("new order=" + AppStore.newOrder);
                          //return;
                          api.updateAgentOrder(
                            AppStore.newOrder,
                            response => {
                              window.showToastMessage(
                                "Success",
                                "New agent order saved"
                              );
                              AppStore.agentCardsChanged = false;
                            },
                            error => {
                              //alert("Error saving profile");
                              window.showToastMessage(
                                "Error",
                                "Error saving profile",
                                "danger",
                                "fe-x"
                              );
                            }
                          );
                        }}
                        class="btn btn-warning"
                      >
                        <i class=" fe fe-check " /> Save agent order
                      </button>

                      <button
                        onClick={() => {
                          AppStore.agentCardsChanged = false;
                        }}
                        class="btn btn-danger"
                      >
                        <i class=" fe fe-x " /> Cancel
                      </button>
                    </>
                  )}
                </div>
                <h4 class="">
                  {" "}
                  <span class="btn btn-white-translucent">
                    <i class="icon-placeholder fe fe-briefcase " />
                  </span>{" "}
                  Agents
                </h4>
                {/*<p class="opacity-75 ">
                  We have inherited from Bootstrap 4, with some tweaks we have
                  <br /> created table styles that blend in our design.
                </p>*/}
              </div>
            </div>
          </div>
        </div>

        <div class="container pull-up">
          {this.planWarning()}

          <div class="row">
            <div class="col-md-12">
              <div class="card m-b-30">
                <div class="card-body">
                  {this.pagination()}
                  <div class="table-responsive">
                    <table class="table table-hover ">
                      <thead>
                        <tr>
                          <th>&nbsp;</th>
                          <th>&nbsp;</th>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Phone</th>
                          <th>Users</th>
                          <th>Status</th>
                          <th>&nbsp;</th>
                        </tr>
                      </thead>
                      <DndProvider backend={HTML5Backend}>
                        {this.state.resultsTotal > 0 && (
                          <AgentList
                            agents={this.state.agents}
                            resultsTotal={this.state.resultsTotal}
                            resultSort={this.state.resultSort}
                          ></AgentList>
                        )}
                      </DndProvider>
                    </table>
                  </div>
                  {this.pagination()}

                  {/*
                  <div class="table-responsive">
                    <table class="table table-hover ">
                      <thead>
                        <tr>
                          <th>&nbsp;</th>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Phone</th>
                          <th>Users</th>
                          <th>Status</th>
                          <th>&nbsp;</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.agents.map(item => (
                          <tr>
                            <td>
                              {item.photo ? (
                                <div class="avatar avatar-sm">
                                  <img
                                    src={item.photo}
                                    class="avatar-img rounded-circle"
                                  />
                                </div>
                              ) : (
                                <div class="avatar avatar-sm">
                                  <span class="avatar-title rounded-circle ">
                                    {item.display_name
                                      .split(" ")
                                      .map((n, i, a) =>
                                        i === 0 || i + 1 === a.length
                                          ? n[0]
                                          : null
                                      )
                                      .join("")}
                                  </span>
                                </div>
                              )}
                            </td>
                            <td>{item.display_name}</td>
                            <td>{item.email}</td>
                            <td>{item.phone}</td>
                            <td>{item.total_users}</td>
                            <td>{item.active == 1 ? "Active" : "Inactive"}</td>
                            <td>
                              <Link
                                to={`/agents/${item.id}`}
                                class="btn btn-primary"
                              >
                                Edit
                              </Link>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
               */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );

    return (
      <div class="row">
        <Modal open={this.state.createModal} onClose={this.handleClose}>
          <div style={styles.modal}>
            <div style={styles.modalTitle}>
              <h2>Create new agent</h2>
              <div
                style={{
                  cursor: "pointer",
                  width: 20,
                  height: 20,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center"
                }}
                onClick={() => {
                  this.setState({ createModal: false });
                }}
              >
                <FiX style={styles.menuIcon} />
              </div>
            </div>

            <Formik
              initialValues={{
                display_name: null,
                email: null,
                password: null
              }}
              validate={values => {
                let errors = {};

                if (!values.display_name) {
                  errors.display_name = "Required";
                }

                if (!values.password) {
                  errors.password = "Required";
                } else if (values.password.length < 6) {
                  errors.password = "Password must be at least 6 characters";
                }

                if (!values.email) {
                  errors.email = "Required";
                } else if (
                  !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
                ) {
                  errors.email = "Invalid email address";
                }
                return errors;
              }}
              onSubmit={(values, { setSubmitting }) => {
                setTimeout(() => {
                  //alert(JSON.stringify(values, null, 2));

                  api.createAgent(
                    values,
                    response => {
                      //alert(JSON.stringify(response));
                      this.setState({ toAgent: response.id });
                    },
                    error => {
                      alert(error.response.data.message);
                    }
                  );

                  setSubmitting(false);
                }, 400);
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting
                /* and other goodies */
              }) => (
                <form onSubmit={handleSubmit}>
                  <p>
                    <label for="display_name">Name</label>
                    <input
                      type="text"
                      name="display_name"
                      id="display_name"
                      placeholder="Agent name"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.display_name}
                    />
                    <span className="form-error">
                      {errors.display_name &&
                        touched.display_name &&
                        errors.display_name}
                    </span>
                  </p>

                  <p>
                    <label for="email">Email</label>
                    <input
                      type="email"
                      name="email"
                      id="email"
                      placeholder="Agent email"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.email}
                    />
                    <span className="form-error">
                      {errors.email && touched.email && errors.email}
                    </span>
                  </p>

                  <p>
                    <label for="password">Password</label>
                    <input
                      type="password"
                      name="password"
                      id="password"
                      placeholder="Agent password"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.password}
                    />
                    <span className="form-error">
                      {errors.password && touched.password && errors.password}
                    </span>
                  </p>

                  <p>
                    <button type="submit" disabled={isSubmitting}>
                      Create agemt
                    </button>
                  </p>

                  <p>
                    <small>You can add more details after creating.</small>
                  </p>
                </form>
              )}
            </Formik>
          </div>
        </Modal>

        <div class="col">
          <div className="box-title">
            <h2>Agents</h2>
            <div style={{ width: 200 }}>
              <button
                onClick={() => {
                  this.setState({ createModal: true });
                }}
              >
                Create new agent
              </button>
            </div>
          </div>
          <div class="content-block-below">
            <table>
              <thead>
                <tr>
                  <th />
                  <th>Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Users</th>
                  <th>Status</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {this.state.agents.map(item => (
                  <tr>
                    <td>
                      {item.photo && (
                        <img
                          src={item.photo}
                          style={{ width: 40, height: 40, borderRadius: 20 }}
                        />
                      )}
                    </td>
                    <td>{item.display_name}</td>
                    <td>{item.email}</td>
                    <td>{item.phone}</td>
                    <td>{item.total_users}</td>
                    <td>{item.active == 1 ? "Active" : "Inactive"}</td>
                    <td>
                      <Button
                        color="primary"
                        component={Link}
                        to={`/agents/${item.id}`}
                      >
                        Edit
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }

  render() {
    if (!UserStore.isAdmin()) {
      return <Redirect to="/" />;
    }

    if (this.state.toAgent) {
      return <Redirect to={"/agents/" + this.state.toAgent} />;
    }

    const user = UserStore.user;

    return (
      <Inner>
        <div class="content">{this.agents()}</div>
      </Inner>
    );
  }
}

const styles = {
  modal: {
    backgroundColor: "#fff",
    padding: 20,
    maxWidth: 500,
    width: "90%",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    position: "absolute"
  },
  modalTitle: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start"
  }
};

export default Agents;
